// src/components/shared/Sidebar.jsx
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const AdminNav = () => (
  <>
    <div className="sb-section">Overview</div>
    <NavLink to="/admin"           end className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-layout-dashboard"></i> Dashboard</NavLink>
    <NavLink to="/admin/tasks"         className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-checklist"></i> All tasks</NavLink>
    <NavLink to="/admin/shipments"     className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-ship"></i> Shipments</NavLink>
    <div className="sb-section" style={{marginTop:8}}>Analytics</div>
    <NavLink to="/admin/analytics"     className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-chart-bar"></i> Reports</NavLink>
    <div className="sb-section" style={{marginTop:8}}>Admin</div>
    <NavLink to="/admin/users"    className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-users"></i> Manage users</NavLink>
    <NavLink to="/admin/roles"    className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-shield-lock"></i> Roles & access</NavLink>
    <NavLink to="/admin/activity" className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-activity"></i> Activity log</NavLink>
    <NavLink to="/admin/settings" className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-settings"></i> Settings</NavLink>
  </>
);

const StaffNav = () => (
  <>
    <div className="sb-section">My work</div>
    <NavLink to="/dashboard" end className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-layout-dashboard"></i> My dashboard</NavLink>
    <NavLink to="/my-tasks"      className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-checklist"></i> My tasks</NavLink>
    <div className="sb-section" style={{marginTop:8}}>Company</div>
    <NavLink to="/shipments"     className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-ship"></i> Shipments</NavLink>
    <NavLink to="/all-tasks"     className={({isActive})=>`nav-item${isActive?' active':''}`}><i className="ti ti-list"></i> All tasks</NavLink>
  </>
);

export default function Sidebar() {
  const { profile, isAdmin, logOut } = useAuth();
  const navigate = useNavigate();
  const initials = profile?.name?.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || 'U';

  const handleLogout = async () => { await logOut(); navigate('/login'); };

  return (
    <div className="sidebar">
      <div className="sb-top">
        <div className="sb-brand">
          <div className="sb-icon">GS</div>
          <div>
            <div className="sb-name">GACH SERVICES</div>
            <span className={`sb-role ${isAdmin ? 'admin' : 'staff'}`}>
              {isAdmin ? 'ADMIN' : 'STAFF'}
            </span>
          </div>
        </div>
      </div>

      <div className="sb-nav">
        {isAdmin ? <AdminNav /> : <StaffNav />}
      </div>

      <div className="sb-foot">
        <div className="avatar" style={{background: isAdmin ? 'var(--blue)' : '#534AB7'}}>
          {profile?.photoURL
            ? <img src={profile.photoURL} alt="" style={{width:'100%',height:'100%',borderRadius:'50%',objectFit:'cover'}} />
            : initials}
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:'12px',fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{profile?.name}</div>
          <div style={{fontSize:'10px',color:'var(--gray-500)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{profile?.email}</div>
        </div>
        <button onClick={handleLogout} style={{background:'none',border:'none',cursor:'pointer',color:'var(--gray-500)',fontSize:'16px'}} title="Sign out">
          <i className="ti ti-logout"></i>
        </button>
      </div>
    </div>
  );
}
